<template>
    <div class="app">
        <scroll @refresh="refresh">
            <no-record :condition="characterInfo" tips='暂无数据'></no-record>
            <section>
                <dl class="field">
                    <dt>身高</dt>
                    <dd>{{characterInfo.height | formatCharacterInfo}}</dd>
                </dl>
                <dl class="field">
                    <dt>体重</dt>
                    <dd>{{characterInfo.weight | formatCharacterInfo}}</dd>
                </dl>
                <dl class="field">
                    <dt>BMI</dt>
                    <dd>
                        {{characterInfo.bmi | formatCharacterInfo}}
                    </dd>
                </dl>
                <dl class="field last">
                    <dt>血型</dt>
                    <dd>
                        {{characterInfo.blood | formatCharacterInfo}}
                    </dd>
                </dl>
            </section>
        </scroll>
    </div>
</template>
<script>
import recordService from 'record.service'
import NoRecord from 'NoRecord';
export default {
    components: {
        NoRecord
    },
    data() {
        return {
            characterInfo: {
//                "height": "175cm",
//                "weight": "70kg",
//                "bmi": "22.86",
//                "blood": "AB"
            }
        }
    },
    created() {
        this.refresh();
    },
    methods: {
        refresh() {
            var voucher = this.$store.state.paramModule.param.healthRecord.voucher;
            recordService.getCharacter({cardNo: voucher.cardNo, cardType: voucher.cardType}).then((res) => {
                this.characterInfo = res;
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// Character.vue?0cfd35e6